import { render, staticRenderFns } from "./lead-center-management.component.vue?vue&type=template&id=666c8d1c&scoped=true&"
import script from "./lead-center-management.component.vue?vue&type=script&lang=js&"
export * from "./lead-center-management.component.vue?vue&type=script&lang=js&"
import style0 from "./lead-center-management.component.vue?vue&type=style&index=0&id=666c8d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c8d1c",
  null
  
)

export default component.exports